import InnerComponent from '@Components/Sales/SalesOrder';
import orgContainer from '@Components/AppContainer';

const ListSalesOrder = () => ((orgContainer(InnerComponent)));
export default ListSalesOrder;
